import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import ErrorAlert from 'components/ErrorAlert';
import { makeSelectError } from 'services/error/selectors';

interface OwnProps {
    children: React.ReactNode;
    FallbackComponent?: React.ReactNode;
    namespace: string;
    displayLogoutButton?: boolean;
    hideFallbackComponent?: boolean;
}

interface ConnectedProps {
    error?: string;
}

type Props = OwnProps & ConnectedProps;

export class ErrorGate extends React.PureComponent<Props> {
    render(): React.ReactNode | null {
        const {
            children,
            error,
            FallbackComponent,
            namespace,
            displayLogoutButton,
            hideFallbackComponent
        } = this.props;

        if (error) {
            if (hideFallbackComponent) {
                return null;
            }

            if (FallbackComponent) {
                return FallbackComponent;
            }

            return (
                <ErrorAlert
                    namespace={namespace}
                    displayLogoutButton={displayLogoutButton}
                    isVisibleOnMount
                />
            );
        }

        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    error: makeSelectError()
});

export default connect(mapStateToProps)(ErrorGate);
